// @flow
import defaultState from '../defaultState';
import type { Customer as State, CustomerActions as Action } from '../types';

const defaultCurrentCustomer = defaultState.currentCustomer;

export default function currentCustomer(
  state: State = defaultCurrentCustomer,
  action: Action
) {
  switch (action.type) {
    case 'UPDATE_CURRENT_CUSTOMER':
      return {
        ...defaultCurrentCustomer,
        ...action.customer,
        settings: action.customer.settings
      };

    case 'UPDATE_CURRENT_CUSTOMER_SETTINGS':
      return {
        ...state,
        settings: action.settings
      };

    case 'UPDATE_CURRENT_CUSTOMER_AGENCIES':
      return {
        ...state,
        agencies: action.agencies
      };

    case 'UPDATE_CURRENT_CUSTOMER_LOCATIONS':
      return {
        ...state,
        locations: action.locations
      };

    case 'SET_CURRENT_CUSTOMER_CURRENT_LOCATION':
      return {
        ...defaultCurrentCustomer,
        ...state,
        currentLocation: {
          ...action.location,
          settings: action.settings
        }
      };

    case 'CLEAR_CURRENT_CUSTOMER_CURRENT_LOCATION':
      return {
        ...defaultCurrentCustomer,
        locations: state.locations,
        currentLocation: defaultCurrentCustomer.currentLocation
      };

    case 'UPDATE_CURRENT_CUSTOMER_AGENCY_SETTINGS':
      return {
        ...state,
        agencySettings: {
          unallocatedAgencies: action.unallocatedAgencies,
          availablePermissions: action.availablePermissions
        }
      };

    case 'UPDATE_ALLOCATED_USERS':
      return {
        ...state,
        users: {
          ...state.users,
          allocated: action.users
        }
      };

    case 'UPDATE_UNALLOCATED_USERS':
      return {
        ...state,
        users: {
          ...state.users,
          unallocated: action.users
        }
      };

    case 'CLEAR_CURRENT_CUSTOMER':
      return defaultCurrentCustomer;

    case 'LOGOUT':
      return defaultCurrentCustomer;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/currentCustomer.js